var $4dbfc55c11ceeff2$exports = {};
$4dbfc55c11ceeff2$exports = {
    "valid": `Geldig`
};


export {$4dbfc55c11ceeff2$exports as default};
//# sourceMappingURL=nl-NL.module.js.map
